import SEO from "../components/SEO";
import CTASection from "../components/sections/CTASection";
import { Link } from "react-router-dom";
import { Heart, Target, Compass } from "lucide-react";

export default function About() {
  return (
    <>
      <SEO
        title="About Pennsylvania Accident Aid"
        description="We're a free service connecting Pennsylvania accident victims with experienced local attorneys. Our mission is simple: get you the help you deserve."
      />
      <section className="pt-12 md:pt-20 pb-16 md:pb-24 px-6 bg-bone">
        <div className="max-w-4xl mx-auto">
          <div className="overline mb-3">About Us</div>
          <h1 className="text-4xl md:text-6xl font-display font-bold text-forest tracking-tight mb-6 text-balance">
            We help Pennsylvanians on the worst day of their lives.
          </h1>
          <p className="text-lg md:text-2xl text-charcoal-soft leading-relaxed mb-8">
            Pennsylvania Accident Aid was built because too many accident victims face overwhelming
            insurance companies, confusing legal systems, and aggressive adjusters — alone.
            We change that by connecting you, in minutes, with the right Pennsylvania attorney for your
            situation. Free. Confidential. No obligation.
          </p>
        </div>
      </section>

      <section className="section bg-bone-alt">
        <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-6">
          {[
            { icon: Heart, title: "Compassion", desc: "An accident is more than a claim. We listen first, advise second, and never pressure." },
            { icon: Target, title: "Precision matching", desc: "Each accident is unique. We connect you with the attorney best equipped for your specific case." },
            { icon: Compass, title: "Pennsylvania-focused", desc: "We only serve Pennsylvania. We know Philadelphia's Court of Common Pleas, the I-76 and I-81 corridors, and Pennsylvania winters." },
          ].map((v, i) => (
            <div key={i} className="card-clay p-7">
              <div className="w-11 h-11 rounded-xl bg-forest/5 text-forest grid place-items-center mb-4">
                <v.icon className="w-5 h-5" />
              </div>
              <h3 className="font-display font-bold text-xl text-forest mb-2">{v.title}</h3>
              <p className="text-charcoal-soft leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="section">
        <div className="max-w-4xl mx-auto">
          <div className="overline mb-3">What We Are (and Aren't)</div>
          <h2 className="text-3xl md:text-5xl font-display font-bold text-forest mb-6 tracking-tight">
            We're not a law firm. We're your starting point.
          </h2>
          <div className="space-y-5 text-base md:text-lg text-charcoal-soft leading-relaxed">
            <p>
              Pennsylvania Accident Aid is a <strong className="text-charcoal">free attorney matching service</strong>.
              When you contact us, we gather basic information about your situation and connect you with an
              independent attorney whose expertise fits your case. The attorney provides legal advice — we don't.
            </p>
            <p>
              <strong className="text-charcoal">Why use us instead of just Googling?</strong> Because choosing
              the right attorney for your specific accident type and county matters enormously. A great
              motorcycle attorney in Cleveland may not be the right fit for a slip-and-fall in Dayton.
              We help you find the right match — fast.
            </p>
            <p>
              Every consultation through our network is <strong className="text-charcoal">free, confidential, and no-obligation</strong>.
              You decide what to do next.
            </p>
          </div>
          <Link to="/contact" className="btn-primary mt-10" data-testid="about-cta">
            Get connected now
          </Link>
        </div>
      </section>

      <CTASection />
    </>
  );
}
